// extracted by mini-css-extract-plugin
module.exports = {"bpSmall":"576px","bpMedium":"768px","bpLarge":"992px","bpXlarge":"1280px"};